module.exports = __webpack_public_path__ + "img/saint-kitts-and-nevis.bf8f9102.svg";